import countries from 'i18n-iso-countries';
import koLocale from 'i18n-iso-countries/langs/ko.json';
import type { ContinentKey, Country } from '../types.js';

countries.registerLocale(koLocale);

const NAME_OVERRIDES: Record<string, string> = {
  RU: '러시아',
  PL: '폴란드',
  TR: '튀르키예',
  ZA: '남아프리카공화국',
  CZ: '체코',
  GB: '영국',
  US: '미국',
  KR: '한국',
  KP: '북한',
  CD: '콩고민주공화국',
  CG: '콩고공화국',
};

export function getKoreanName(iso2: string): string {
  const override = NAME_OVERRIDES[iso2];
  if (override !== undefined) return override;
  const name = countries.getName(iso2, 'ko');
  return name ?? iso2;
}

export function normalizeContinent(raw: string): ContinentKey | null {
  switch (raw) {
    case 'Asia':
      return 'Asia';
    case 'Europe':
      return 'Europe';
    case 'Africa':
      return 'Africa';
    case 'North America':
      return 'North America';
    case 'South America':
      return 'South America';
    case 'Oceania':
      return 'Oceania';
    case 'Seven seas (open ocean)':
    case 'Antarctica':
    default:
      return null;
  }
}

export function buildCountry(
  iso2: string,
  iso3: string,
  continent: ContinentKey,
): Country {
  return {
    iso2,
    iso3,
    nameKo: getKoreanName(iso2),
    continent,
  };
}
